import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
const IconButton = ({ Icon, containerStyle, onClick }) => {
    const style = `${containerStyle} rounded-md p-2 bg-gray-100 bg-opacity-10 hover:bg-opacity-20 text-gray-200`;
    return (_jsx("button", { className: style, onClick: onClick, children: _jsx(FontAwesomeIcon, { className: "cursor-pointer", icon: Icon, size: "2xl" }) }));
};
export default IconButton;
